import actionTypes from 'redux/actions/actionTypes'
import { isEmpty } from 'helpers/activities/validations/drawIt'
import referenceMediaTypes from 'helpers/enums/referenceMediaTypes'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import { getFlag } from 'helpers/featureFlags/provider'
import confirmTypes from 'helpers/enums/confirmTypes'
import lessonTypes from 'helpers/enums/lessonTypes'

const defaultTimer = {
	value: null,
}

export const defaultTransformations = {
	isFlippedHorizontally: false,
	isFlippedVertically: false,
	rotation: 0,
	scale: 1,
	offsetX: 0,
	offsetY: 0,
}

const defaultInstructions = {
	text: '',
}

const defaultIcon = {
	id: 0,
	uploadId: '',
	type: '',
	versions: {},
	link: '',
	status: '',
	message: '',
}

const defaultIconBackground = {
	id: 0,
	uploadId: '',
	type: '',
	versions: {},
	link: '',
	status: 'initial',
	transformations: {
		...defaultTransformations,
	},
}

const defaultState = {
	entityUID: '',
	presentationId: '',
	presentationUid: '',
	instructions: {
		...defaultInstructions,
	},
	icon: defaultIcon,
	iconBackground: {
		...defaultIconBackground,
	},
	iconBackgroundInitialTransformations: {
		...defaultTransformations,
	},
	isModified: false,
	canReplace: false,
	expandedHeader: true,
	timer: {
		...defaultTimer,
	},
	cancelUrl: '',
	isAudioRecorderActive: false,
	confirms: [],
}

function createInitializeSuccess(state, action) {
	let newState = {...state}
	newState.instructions = {
		...defaultInstructions,
		text: action.data.instructions,
	}
	newState.icon = mapIcon(action.data.iconReferenceMedia)
	newState.iconBackground = mapIconBackground(action.data.iconBackground)
	newState.iconBackgroundInitialTransformations =
		newState.iconBackground.transformations
	newState.presentationId = action.data.presentationId
	newState.presentationUid = action.data.presentationUid
	newState = {
		...newState,
		timer: {
			value: action.data.timer,
		},
		cancelUrl: action.data.cancelUrl,
	}
	newState.canReplace = isEmpty(newState) || newState.canReplace
	return newState
}

function mapIcon(data) {
	return {
		id: (data.id) ? data.id : defaultIcon.id,
		uploadId: (data.uploadId) ? data.uploadId : defaultIcon.uploadId,
		type: (data.type) ? data.type : defaultIcon.type,
		versions: (data.versions) ? data.versions : defaultIcon.versions,
		link: (data.link) ? data.link : defaultIcon.link,
		status: (data.status) ? data.status : defaultIcon.status,
	}
}

function mapIconBackground(data) {
	if (!data) {
		return defaultIconBackground
	}
	return {
		//TODO avoid this Number Cast, check Draw it & Matching Pairs
		id: (data.id) ? Number(data.id) : defaultIconBackground.id,
		uploadId: (data.uploadId) ? data.uploadId : defaultIconBackground.uploadId,
		type: (data.type) ? data.type : defaultIconBackground.type,
		versions: (data.versions) ? data.versions : defaultIconBackground.versions,
		link: (data.ink) ? data.link : defaultIconBackground.link,
		status: (data.status) ? data.status : '',
		transformations: mapTransformations( (data.versions && data.versions.transformations) ? data.versions.transformations : defaultTransformations),
	}
}

function mapTransformations(data) {
	if (!data) {
		return defaultTransformations
	}
	return {
		isFlippedHorizontally: data.isFlippedHorizontally,
		isFlippedVertically: data.isFlippedVertically,
		rotation: Number(data.rotatedDegrees),
		scale: Number(data.scale),
		offsetX: Number(data.offsetX),
		offsetY: Number(data.offsetY),
	}
}


function createInitialize(state, action) {
	if (!action.drawItUID) {
		return state
	}
	return {
		...state,
		entityUID: action.drawItUID,
	}
}

function changeInstructions(state, action) {
	const newState = {
		...state,
		isModified: true,
		instructions: {
			...state.instructions,
			text: action.value,
		},
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function showIconLoading(icon) {
	return {
		...icon,
		status: 'uploading',
		message: '',
	}
}

function showAudioPlayerLoading(icon) {
	return {
		...icon,
		status: 'uploading',
		message: '',
		type: referenceMediaTypes.AUDIO_RECORDER,
	}
}

function showReferenceMediaLoading(state) {
	return {
		...state,
		icon: state.isAudioRecorderActive
			? showAudioPlayerLoading(state.icon)
			: showIconLoading(state.icon),
		isAudioRecorderActive: false,
	}
}

function showBackgroundImageLoading(state) {
	return {
		...state,
		iconBackground: showIconLoading(state.iconBackground),
	}
}

function validateReferenceMediaSuccess(state, action) {
	return {
		...state,
		icon: {
			...state.icon,
			uploadId: action.uploadId,
		},
	}
}

function validateBackgroundImageSuccess(state, action) {
	return {
		...state,
		iconBackground: {
			...state.iconBackground,
			uploadId: action.uploadId,
		},
	}
}

function uploaderUploadSuccess(state, action) {
	const newState = {
		...state,
		isModified: true,
		icon: mapIcon(action.icon),
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function processingIconSuccess(state, action) {
	if (action.icon.id === state.icon.id) {
		const newState = {
			...state,
			isModified: true,
			icon: mapIcon(action.icon),
		}
		newState.canReplace = isEmpty(newState)
		return newState
	} else {
		return state
	}
}

function backgroundImageUploadSuccess(state, action) {
	const newState = {
		...state,
		isModified: true,
		expandedHeader: false,
		iconBackground: mapIconBackground(action.icon),
		iconBackgroundInitialTransformations: defaultTransformations,
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function iconUploadError(icon, action) {
	return {
		...icon,
		message: action.message,
		status: '',
	}
}

function uploaderUploadError(state, action) {
	return {
		...state,
		icon: iconUploadError(state.icon, action),
	}
}

function processingIconError(state, action) {
	if (action.icon.id === state.icon.id) {
		return {
			...state,
			icon: iconUploadError(state.icon, action),
		}
	} else {
		return state
	}
}

function backgroundImageUploadError(state, action) {
	return {
		...state,
		iconBackground: iconUploadError(state.iconBackground, action),
	}
}

function deleteReferenceMedia(state) {
	const newState = {
		...state,
		isModified: true,
		icon: { ...defaultIcon },
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function iconBackgroundScale(state, value) {
	return {
		...state.iconBackground,
		transformations: {
			...state.iconBackground.transformations,
			scale: value,
		},
	}
}

function iconBackgroundReset(state) {
	return {
		...state.iconBackground,
		transformations: defaultTransformations,
	}
}

function iconBackgroundFlipVertically(state) {
	return {
		...state.iconBackground,
		transformations: {
			...state.iconBackground.transformations,
			isFlippedVertically: !state.iconBackground.transformations.isFlippedVertically,
		},
	}
}

function iconBackgroundFlipHorizontally(state) {
	return {
		...state.iconBackground,
		transformations: {
			...state.iconBackground.transformations,
			isFlippedHorizontally: !state.iconBackground.transformations.isFlippedHorizontally,
		},
	}
}

function iconBackgroundRotate(state, value) {
	return {
		...state.iconBackground,
		transformations: {
			...state.iconBackground.transformations,
			rotation: value,
		},
	}
}

function iconBackgroundChangeOffset(state, offsetX, offsetY) {
	return {
		...state.iconBackground,
		transformations: {
			...state.iconBackground.transformations,
			offsetX,
			offsetY,
		},
	}
}

function deleteBackgroundImage(state) {
	const newState = {
		...state,
		isModified: true,
		iconBackground: { ...defaultIconBackground, status: '' },
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function addReferenceMediaClick(state) {
	const newState = {...state}
	const newIcon = {
		...state.icon,
		message: '',
	}
	newState.icon = newIcon
	return newState
}

function flipBackgroundImageHorizontally(state) {
	const newState = {
		...state,
		isModified: true,
		iconBackground: iconBackgroundFlipHorizontally(state),
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function flipBackgroundImageVertically(state) {
	const newState = {
		...state,
		isModified: true,
		iconBackground: iconBackgroundFlipVertically(state),
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function resetBackgroundImageProperties(state) {
	const newState = {
		...state,
		isModified: true,
		iconBackground: iconBackgroundReset(state),
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function rotateBackgroundImage(state, action) {
	const newState = {
		...state,
		isModified: true,
		iconBackground: iconBackgroundRotate(state, action.rotation),
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function scaleBackgroundImage(state, action) {
	const newState = {
		...state,
		isModified: true,
		iconBackground: iconBackgroundScale(state, action.scale),
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function toggleHeader(state) {
	return {
		...state,
		expandedHeader: !state.expandedHeader,
	}
}

function saveTimer(state, action) {
	//Adding previous timer value to action in case it needs to be reverted if service fails when saving
	action.previous_timer = state.timer
	const newState = {
		...state,
		isModified: true,
		timer: {
			...state.timer,
			value: action.value,
		},
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function deleteTimer(state, action) {
	//Adding previous timer value to action in case it needs to be reverted if service fails when saving
	action.previous_timer = state.timer
	const newState = {
		...state,
		timer: defaultTimer,
		isModified: true,
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function revertTimer(state, action) {
	const newState = {
		...state,
		isModified: true,
		timer: action.previous_timer,
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function finalize() {
	return {
		...defaultState,
	}
}

function changeImageOffset(state, action) {
	const newState = {
		...state,
		isModified: true,
		iconBackground: iconBackgroundChangeOffset(state, action.offsetX, action.offsetY),
	}
	newState.canReplace = isEmpty(newState)
	return newState
}

function handleReferenceMediaOpen(state, action) {
	if (getFlag(featureFlagsTypes.AUDIO_RECORDER_DRAWIT) &&
		action.mediaType === referenceMediaTypes.AUDIO_RECORDER) {
		return {
			...state,
			isAudioRecorderActive: true,
		}
	} else {
		return state
	}
}

function deleteAudioPlayer(state) {
	return {
		...state,
		icon: defaultIcon,
	}
}

function deleteAudioRecorder(state, action) {
	if (action.type === actionTypes.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRM && action.hasAudioRecorded) {
		return state
	} else {
		return {
			...state,
			icon: defaultIcon,
			isAudioRecorderActive: false,
		}
	}
}

function clearConfirms(state) {
	return {
		...state,
		confirms: [],

	}
}

function handleActivityBanksSelected(state, action) {
	if (!state.canReplace && action.lesson.data.type === lessonTypes.DRAW_IT) {
		return {
			...state,
			confirms: [{
				type: confirmTypes.ACTIVITY_REPLACE,
				props: {
					lesson: action.lesson,
				},
			}],
		}
	} else {
		return state
	}
}

function handleActivityBanksSelectedConfirmed(state) {
	const newState = {
		...state,
		canReplace: true,
	}
	return clearConfirms(newState)
}

const drawItReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.DRAW_IT_INITIALIZE_CREATION_TOOL:
		case actionTypes.DRAW_IT_UPDATE_CREATION_TOOL:
		case actionTypes.DRAW_IT_INITIALIZE_STANDALONE:
		case actionTypes.QUICK_LAUNCH_DRAW_IT_INITIALIZE_CREATION_TOOL:
		case actionTypes.QUICK_LAUNCH_DRAW_IT_CREATE_LESSON_SUCCESS:
		{
			return createInitialize(state, action)
		}
		case actionTypes.DRAW_IT_INITIALIZE_SUCCESS: {
			return createInitializeSuccess(state, action)
		}
		case actionTypes.DRAW_IT_CHANGE_INSTRUCTIONS: {
			return changeInstructions(state, action)
		}
		case actionTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA: {
			return showReferenceMediaLoading(state)
		}
		case actionTypes.DRAW_IT_UPLOADER_UPLOAD_SUCCESS: {
			return uploaderUploadSuccess(state, action)
		}
		case actionTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA_ERROR:
		case actionTypes.DRAW_IT_UPLOADER_VALIDATE_ERROR:
		case actionTypes.DRAW_IT_UPLOADER_UPLOAD_ERROR:
		case actionTypes.DRAW_IT_UPLOADER_VALIDATE_CONTENT_ERROR: {
			return uploaderUploadError(state, action)
		}
		case actionTypes.DRAW_IT_DELETE_REFERENCE_MEDIA_SUCCESS: {
			return deleteReferenceMedia(state, action)
		}
		case actionTypes.DRAW_IT_ADD_REFERENCE_MEDIA_CLICK: {
			return addReferenceMediaClick(state, action)
		}
		case actionTypes.DRAW_IT_UPLOAD_BACKGROUND_IMAGE: {
			return showBackgroundImageLoading(state, action)
		}
		case actionTypes.DRAW_IT_UPLOAD_BACKGROUND_IMAGE_SUCCESS: {
			return backgroundImageUploadSuccess(state, action)
		}
		case actionTypes.DRAW_IT_VALIDATE_BACKGROUND_IMAGE_ERROR:
		case actionTypes.DRAW_IT_UPLOAD_BACKGROUND_IMAGE_ERROR: {
			return backgroundImageUploadError(state, action)
		}
		case actionTypes.DRAW_IT_DELETE_BACKGROUND_IMAGE: {
			return deleteBackgroundImage(state, action)
		}
		case actionTypes.DRAW_IT_FLIP_BACKGROUND_IMAGE_HORIZONTALLY: {
			return flipBackgroundImageHorizontally(state, action)
		}
		case actionTypes.DRAW_IT_FLIP_BACKGROUND_IMAGE_VERTICALLY: {
			return flipBackgroundImageVertically(state, action)
		}
		case actionTypes.DRAW_IT_RESET_BACKGROUND_IMAGE_PROPERTIES: {
			return resetBackgroundImageProperties(state, action)
		}
		case actionTypes.DRAW_IT_ROTATE_BACKGROUND_IMAGE: {
			return rotateBackgroundImage(state, action)
		}
		case actionTypes.DRAW_IT_SCALE_BACKGROUND_IMAGE: {
			return scaleBackgroundImage(state, action)
		}
		case actionTypes.DRAW_IT_TOGGLE_HEADER: {
			return toggleHeader(state, action)
		}
		case actionTypes.DRAW_IT_VALIDATE_REFERENCE_MEDIA_SUCCESS: {
			return validateReferenceMediaSuccess(state, action)
		}
		case actionTypes.DRAW_IT_VALIDATE_BACKGROUND_IMAGE_SUCCESS: {
			return validateBackgroundImageSuccess(state, action)
		}
		case actionTypes.PROCESSING_ICON_SUCCESS: {
			return processingIconSuccess(state, action)
		}
		case actionTypes.PROCESSING_ICON_ERROR: {
			return processingIconError(state, action)
		}
		case actionTypes.DRAW_IT_SAVE_TIMER:
			return saveTimer(state, action)
		case actionTypes.DRAW_IT_DELETE_TIMER:
			return deleteTimer(state, action)
		case actionTypes.DRAW_IT_TIMER_SAVE_ERROR:
			return revertTimer(state, action)
		case actionTypes.QUICK_LAUNCH_DRAW_IT_FINALIZE_CREATION_TOOL:
			return finalize()
		case actionTypes.DRAW_IT_CHANGE_IMAGE_OFFSET:
			return changeImageOffset(state, action)
		case actionTypes.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRM:
		case actionTypes.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRMED:
			return deleteAudioRecorder(state, action)
		case actionTypes.DRAW_IT_REFERENCE_MEDIA_MENU_CLICK:
			return handleReferenceMediaOpen(state, action)
		case actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED:
			return handleActivityBanksSelected(state, action)
		case actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED_CONFIRMED:
			return handleActivityBanksSelectedConfirmed(state, action)
		case actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED_CANCELLED:
			return clearConfirms(state, action)
		case actionTypes.DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRMED:
			return deleteAudioPlayer(state)
		default: return state
	}
}

export default drawItReducer
